import React, { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { sendOTPOnEmail } from '../../services/auth';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { AuthContainer } from './AuthContainer';
import { OTPInput } from './OTPInput';
// import {useAlert} from "../../context/alert";

const required_field = "*обязательное поле";
const wrong_number = "*некорректный номер";

export const SignInPhoneForm = () => {
    const [phoneTouched, setPhoneTouched] = useState(false);
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [isPhoneFilled, setPhoneFilled] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [isOTPSent, setIsOTPSent] = useState(false);

    const { mutate: getOTP } = useMutation({
        mutationFn: sendOTPOnEmail,
        onSuccess: (data) => {
            setIsOTPSent(true);
            setEmail(data.email);
        }
    });

    const fixedText = "+7";

    const handlePhoneTouch = () => {
        if (!phoneTouched) {
            setPhone(fixedText)
            setPhoneTouched(true)
        }
    }


    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setErrorText('');
        let phoneNumber = e.target.value;
        const phoneNumberRegex = /^\+\d{1,11}$/;

        if (!phoneNumber.startsWith(fixedText)) {
            phoneNumber = fixedText;
        }

        if (['+', ''].includes(phoneNumber)) {
            setPhone(phoneNumber);
        }
        if (phoneNumberRegex.test(phoneNumber)) {
            setPhone(phoneNumber);
        }
    };

    // Проверяем заполненность телефона для смены цвета кнопки
    useEffect(() => {
        const fullPhoneNumberRegex = /^\+\d{11}$/;
        setPhoneFilled(fullPhoneNumberRegex.test(phone))
    }, [phone]);

    const submit: React.MouseEventHandler<HTMLButtonElement> = () => {
        const valid = isValidPhoneNumber(phone, "RU");
        if (!valid) {
            setErrorText(wrong_number);
        }
        if (phone && valid) {
            getOTP({ phone });
        }
        if (phone === "" || phone === fixedText) {
            setErrorText(required_field);
        }
    };

    if (isOTPSent) {
        return <OTPInput email={email} phone={phone} />;
    }

    return (
        <AuthContainer>
            <div className="w-full">
                <div
                    className="mb-8 font-manager-acrom-h4-24-medium-acrom font-[number:var(--manager-acrom-h4-24-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-h4-24-medium-acrom-font-size)] text-center tracking-[var(--manager-acrom-h4-24-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-h4-24-medium-acrom-line-height)] [font-style:var(--manager-acrom-h4-24-medium-acrom-font-style)]">
                    Авторизация
                </div>

                <div
                    className="w-full flex flex-col font-manager-acrom-ph1-18-medium-acrom font-[number:var(--manager-acrom-ph1-18-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph1-18-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-18-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-18-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph1-18-medium-acrom-font-style)]">
                    <input
                        type="tel"
                        placeholder='Номер телефона*'
                        onChange={handlePhoneChange}
                        onClick={handlePhoneTouch}
                        value={phone}
                        className={`bg-melon-light-grey rounded-lg h-12 text-center w-full ${errorText === required_field ? "border-2 border-red-300" : ""}`}
                    />

                    <p className="text-red-500 text-sm mt-1 mb-2">
                        {errorText}
                    </p>
                </div>
                <div className="w-full flex flex-col justify-center items-center">
                    <button
                        onClick={submit}
                        className={
                            'w-full h-12 inline-flex items-center justify-center flex-[0_0_auto] rounded-lg gap-2.5 px-5 py-4 relative font-manager-acrom-ph1-18-medium-acrom font-[number:var(--manager-acrom-ph1-18-medium-acrom-font-weight)] text-[length:var(--manager-acrom-ph1-18-medium-acrom-font-size)] text-center tracking-[var(--manager-acrom-ph1-18-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-18-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-18-medium-acrom-font-style)] '
                            + (isPhoneFilled ? "bg-melon-yellow" : "bg-melon-light-grey")
                        }
                    >
                        Далее
                    </button>
                    <a
                        href="mailto:report@melonfashion.com"
                        className="mt-10 font-manager-acrom-links font-[number:var(--manager-acrom-links-font-weight)] text-black text-[length:var(--manager-acrom-links-font-size)] text-center tracking-[var(--manager-acrom-links-letter-spacing)] leading-[var(--manager-acrom-links-line-height)] underline whitespace-nowrap [font-style:var(--manager-acrom-links-font-style)]"
                    >Связаться с тех. поддержкой</a>
                </div>
            </div>
        </AuthContainer>
    );
};
